import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import arrowLeftImg from '../../images/arrow-left-blue.svg';

import style from './Back.module.css';

const Back = React.memo(({ path, text, clientId }) => {
  return (
    <div className={style.back}>
      <Link to={path}>
        <img src={arrowLeftImg} alt="" />
        {text}
      </Link>
      <div className={style.text}>
        <span>{clientId ? `Client ID: ${clientId}` : ''}</span>
      </div>
    </div>
  );
});

Back.propTypes = {
  path: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  clientId: PropTypes.string,
};

export default Back;
